/* Cart – “voeg geselecteerde toe” (simple + variable) */
import { $, $$, wooRefreshFragments, wooAddedToCart } from './utils.js';

export function mount() {
  const bulkBtn = $('[data-wk-xs-add-all]');
  if (!bulkBtn) return;

  bulkBtn.addEventListener('click', async () => {
    const grid = $('[data-wk-xs-grid]');
    if (!grid) return;
    const checks = $$('.wk-xs-check__input:checked', grid);
    if (!checks.length) return;

    bulkBtn.disabled = true;
    bulkBtn.classList.add('is-busy');

    try {
      for (const chk of checks) {
        const pid = parseInt(chk.getAttribute('data-product-id') || '0', 10);
        const vid = parseInt(chk.getAttribute('data-variation-id') || '0', 10);
        const attrs = (window.jQuery && window.jQuery(chk).data('attrs')) || {};
        await addToCartAjax(pid, vid, attrs);
      }
      wooRefreshFragments();
      wooAddedToCart();
    } catch (err) {
      console.error('[Cart] bulk add failed', err);
    } finally {
      bulkBtn.disabled = false;
      bulkBtn.classList.remove('is-busy');
      checks.forEach(c => { c.checked = false; });
    }
  });
}

function addToCartAjax(product_id, variation_id = 0, attributes = {}) {
  return new Promise((resolve) => {
    if (!window.jQuery || !window.wc_add_to_cart_params) { resolve(); return; }
    const $ = window.jQuery;

    const data = {
      'add-to-cart': product_id,
      product_id,
      quantity: 1
    };
    if (variation_id) {
      data.variation_id = variation_id;
      Object.assign(data, attributes || {});
    }

    const url = window.wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart');
    $.post(url, data).always(() => resolve());
  });
}
